// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@steiner/App/Components/Notify";
import { changeCustomerSelectCustomerContainerStyles } from "@steiner/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionHidden = {
    css: css`
        display: none;
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    gap: 20,
    css: css`
        &&&& {
            max-width: 50%;
            margin-inline: 0 auto;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        margin-top: 5px;
        ${xScreen("lt", "sm")} {
            flex-direction: column-reverse;
            row-gap: 16px;
            button {
                width: 100%;
                margin: 0;
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 16px;
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin-top: 16px;
            margin-bottom: 0;
        `,
    }),
};

changeCustomerSelectCustomerContainerStyles.billToSelectorGridItem = {
    width: 12,
    css: css`
        position: relative;
    `,
};
changeCustomerSelectCustomerContainerStyles.shipToSelectorGridItem = {
    width: 12,
    css: css`
        position: relative;
    `,
};
